import React, { useState } from 'react';
import { Copy, Download } from 'lucide-react';

export const TranscriptionDisplay = ({ transcription, isLoading }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(transcription);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleDownload = () => {
    const blob = new Blob([transcription], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `transcricao-medica-${new Date().toISOString().split('T')[0]}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Processando transcrição com IA...</p>
      </div>
    );
  }

  if (!transcription) return null;

  return (
    <div className="transcription-container">
      <div className="transcription-header">
        <h3>História Clínica Estruturada</h3>
        <div className="transcription-actions">
          <button onClick={handleCopy} className="action-btn">
            <Copy size={16} />
            {copied ? 'Copiado!' : 'Copiar'}
          </button>
          <button onClick={handleDownload} className="action-btn">
            <Download size={16} />
            Baixar
          </button>
        </div>
      </div>
      <div className="transcription-content">
        <pre>{transcription}</pre>
      </div>
    </div>
  );
};
